import R from 'ramda';
import { UPDATE_CONTENT } from './actions';

const updateContent = (state, { key, data, shouldMerge = true }) => {
  if (shouldMerge !== true) {
    return {
      ...state,
      [key]: data,
    };
  }

  if (shouldMerge === true && Array.isArray(state[key])) {
    return {
      ...state,
      [key]: R.concat(state[key], data),
    };
  }

  // shouldMerge === true && !Array.isArray(state[key])
  return {
    ...state,
    [key]: {
      ...state[key],
      ...data,
    },
  };
};

const reducer = {
  [UPDATE_CONTENT]: updateContent,
};

export default (state = {}, action) =>
  (action.type && reducer[action.type] ? reducer[action.type](state, action) : state);
